import { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent } from '@/components/ui/card';
import { MessageSquare, Mail, Phone, Clock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const getToken = () => localStorage.getItem('admin_token');

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    axios.get(`${API}/admin/contacts`, { headers: { Authorization: `Bearer ${getToken()}` } })
      .then(r => setMessages(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-messages-page">
      <h1 className="font-heading text-2xl font-medium mb-8">Contact Messages</h1>

      <div className="space-y-4">
        {messages.map((m, i) => (
          <Card key={m.id} className="rounded-2xl border-border" data-testid={`message-card-${i}`}>
            <CardContent className="p-6">
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="font-heading font-medium text-lg">{m.name}</h3>
                  <div className="flex items-center gap-4 mt-1 text-sm text-muted-foreground">
                    <span className="flex items-center gap-1"><Mail className="w-3.5 h-3.5" /> {m.email}</span>
                    {m.phone && <span className="flex items-center gap-1"><Phone className="w-3.5 h-3.5" /> {m.phone}</span>}
                  </div>
                </div>
                <span className="flex items-center gap-1 text-xs text-muted-foreground">
                  <Clock className="w-3 h-3" /> {new Date(m.created_at).toLocaleString()}
                </span>
              </div>
              <p className="mt-4 text-sm text-muted-foreground leading-relaxed bg-muted/50 p-4 rounded-xl">{m.message}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      {messages.length === 0 && (
        <div className="text-center py-16">
          <MessageSquare className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">No messages yet.</p>
        </div>
      )}
    </div>
  );
}
